import React, { useState, useEffect } from "react";

/**
 * ProgressBar component that:
 *  - Increments from 0% up to 90% over ~5 minutes (300 seconds).
 *  - Jumps to 100% once isDataReady is true.
 */
function ProgressBar({ isDataReady }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // We'll increment progress from 0 to 90% over 5 minutes (300 seconds).
    // 300s / 90 steps => ~3.33s per step.
    let intervalTime = 3333; // ms
    let step = 1;
    let maxPercent = 90;

    let intervalId = setInterval(() => {
      setProgress((prev) => {
        // If data isn't ready, increment up to 90%.
        if (!isDataReady && prev < maxPercent) {
          return prev + step;
        }
        // If we're already at 90%, hold there until data is ready.
        if (!isDataReady && prev >= maxPercent) {
          return prev;
        }
        // If data is ready, jump to 100%.
        if (isDataReady) {
          return 100;
        }
        return prev;
      });
    }, intervalTime);

    return () => {
      clearInterval(intervalId);
    };
  }, [isDataReady]);

  // Simple inline style for the container and the fill
  const containerStyle = {
    marginTop: "300px",
    width: "300px",
    height: "30px",
    backgroundColor: "#f5f5f5",
    borderRadius: "15px",
    overflow: "hidden",
    border: "1px solid #ccc",
  };

  const progressFillStyle = {
    width: `${progress}%`,
    height: "100%",
    backgroundColor: "#56539D",
    transition: "width 0.5s ease-out",
  };

  const textStyle = {
    textAlign: "center",
    marginTop: "10px",
    color: "#56539D",
    fontWeight: "bold",
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div style={containerStyle}>
        <div style={progressFillStyle}></div>
      </div>
      <div style={textStyle}>Loading: {progress}%</div>
    </div>
  );
}

export default ProgressBar;
